// App utils
import { datajsFirst, datajsArray } from '../shared/utils';

(function() {
	const toggleSearchForm = e => {
		const form = e.target.closest('.c-siteHeaderSearch');
		const input = datajsFirst('searchform-input', form);

		const closeSearch = documentClickEvent => {
			if (!documentClickEvent.target.closest('.c-siteHeaderSearch')) {
				form.classList.remove('is-active');
				form.reset();

				// Remove the event listener
				document.removeEventListener('click', closeSearch);
			}
		};

		if (!form || !input) {
			return;
		}

		form.classList.toggle('is-active');
		input.focus();

		// Listen for all clicks on the document
		document.addEventListener('click', closeSearch);
	};
	const searchToggle = () => {
		const toggle = datajsArray('searchform-toggle');

		toggle.forEach(element => element.addEventListener('click', toggleSearchForm));
	};

	document.addEventListener('DOMContentLoaded', searchToggle);
})();
